export const Footer: React.FC = () => {
  return (
    <div className="hd:absolute bottom-0 sm:w-70v flex justify-center fullhd:pb-4 bg-secondary">
      <span className="text-text-secondary">
        created by <b><a href="https://github.com/KielpinskiJ/">KielpinskiJ</a></b> - <a href="https://devchallenges.io/">devChallenges.io</a>
      </span>
    </div>
  )
}